import {getApiUrl} from "../utils/util-functions";

export const getBankOfAmericaCaptureContext = async () => {
    return fetch(getApiUrl() + '/payment/capture-context', {
        body: JSON.stringify({target_host: window.location.origin}),
        method: 'POST'
    })
        .then((response) => {
            return response.json();
        })
        .then((response: any) => {
            return response['response'];
        });
};